// extracted by mini-css-extract-plugin
export default {"title":"Login_title__vcg8P","Notification":"Login_Notification__JfYZk"};